import {createFileRoute} from '@tanstack/react-router';

import {parseNonEmpty, parsePage} from '@/lib/search-params';
import {ClientsListPage} from '@/modules/clients/pages/ClientsListPage';
import {ACTIVITY_ORDER, type Activity} from '@/lib/activity';

/**
 * URL state for the clients index. All fields optional so links from
 * elsewhere can land here bare; the page reads defaults (`page ?? 1`).
 *
 * `status` is `active` | `inactive`, absent meaning "all" (DERP-240). It
 * replaced the old four-stage relationship status *and* a separate `archived`
 * boolean that filtered on the same thing — an unrecognised value (including a
 * stale `?status=dormant` link) parses to `undefined` and lands on "All".
 */
export interface ClientsListSearch {
  status?: Activity;
  q?: string;
  page?: number;
}

function parseStatus(value: unknown): Activity | undefined {
  return ACTIVITY_ORDER.find((s) => s === value);
}

const validateClientsListSearch = (search: Record<string, unknown>): ClientsListSearch => ({
  status: parseStatus(search.status),
  q: parseNonEmpty(search.q),
  page: parsePage(search.page),
});

export const Route = createFileRoute('/_authenticated/clients/')({
  validateSearch: validateClientsListSearch,
  component: ClientsListPage,
});
